import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	enableFinancingServices: false,
	hideMonthlyRates: true,
	showPrices: false,
	nextBestActions: [
		{
			description: 'Stok araç arama',
			icon: '',
			labelText: 'Stok araç arama',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://stokarac.audi.com.tr/?_gl=1*ujl975*_ga*NTczMjc4MTU4LjE3MDAwMzM4MTA.*_ga_MN5480N9KK*MTcwMTA3NDk1MS4xOS4xLjE3MDEwNzUwNjUuNjAuMC4w',
		},
		{
			description: 'Yetkili Satıcı ile iletişime geçiniz',
			icon: 'send',
			labelText: 'Yetkili Satıcı ile iletişime geçiniz',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://form.audi.com.tr/Forms/Bilgilendirme_formu?_gl=1*1idus1i*_ga*NjkxNDM4MjY1LjE3MDkwOTYwNDk.*_ga_MN5480N9KK*MTcxMDIzNjI5My4zMC4xLjE3MTAyMzYyOTMuNjAuMC4yMDM4MTAzMTk5',
		},
		{
			description: 'Test sürüşü ayarlayın',
			icon: 'test-drive',
			labelText: 'Test sürüşü ayarlayın',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://form.audi.com.tr/forms/TestSurus_Formu?_gl=1*1idus1i*_ga*NjkxNDM4MjY1LjE3MDkwOTYwNDk.*_ga_MN5480N9KK*MTcxMDIzNjI5My4zMC4xLjE3MTAyMzYyOTMuNjAuMC4yMDM4MTAzMTk5',
		},
	],
	summaryFooterCta: {
		description: 'Audi Kod',
		icon: 'code',
		labelText: 'Audi Kod',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
};

export const local_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};
